var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"voice-icon",class:{'animate': _vm.playing, 'right': _vm.direction == 'right'}},[_c('div',{staticClass:"cricle"}),_vm._v(" "),_c('div',{staticClass:"cricle"}),_vm._v(" "),_c('div',{staticClass:"cricle"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1451ba8b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Common/voiceIcon.vue
// module id = null
// module chunks = 